//Этот компонент выводит карточку с информацией о необходимых документах и возможностью загрузить или скачать их!
//С левой стороны карточки выводится вся необходимая информация о доках, с правой стороны - кнопка для вышеописанных целей!
//Есть возможность передавать свои стили, либо будут применены стили по-дефолту
//Нужно будет переделать interface - пока не готово апи с необходимыми ключами!

import React, { FC } from "react";
import classes from "./style/UI_ITOModuleDocuments.module.css";
interface UI_ModuleTitleCardProps {
  title: React.ReactNode;
  style?: React.CSSProperties;
  titleDown?: React.ReactNode;
  icon?: React.ReactNode;
  tag?: {
    title: string;
    color: string;
  };
}

export const UI_ModuleDocuments: FC<UI_ModuleTitleCardProps> = (props) => {
  const { title, style, icon, titleDown } = props;
  return (
    <div className={classes.cardWrapper} style={style}>
      <div className={classes.titleWrapper}>
        <div className={classes.title}>{title}</div>
        <div className={classes.titleDown}>{titleDown}</div>
      </div>
      <div className={classes.iconWrapper}>{icon}</div>
    </div>
  );
};
